<template>
  <div class="base-param">
    <div class="search-container">
      <el-form :inline="true" class="search-form">
        <el-form-item label="中文名称">
          <el-input v-model="searchForm.name" placeholder="请输入中文名称"></el-input>
        </el-form-item>
        <el-form-item label="编码1">
          <el-input v-model="searchForm.code1" placeholder="请输入编码1"></el-input>
        </el-form-item>
        <el-form-item label="编码2">
          <el-input v-model="searchForm.code2" placeholder="请输入编码2"></el-input>
        </el-form-item>
        <el-form-item label="编码3">
          <el-input v-model="searchForm.code3" placeholder="请输入编码3"></el-input>
        </el-form-item>
        <el-form-item label="英文名称">
          <el-input v-model="searchForm.enName" placeholder="请输入英文名称"></el-input>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-select v-model="searchForm.enabled" placeholder="全部">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否过期">
          <el-select v-model="searchForm.expired" placeholder="全部">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="type-tabs">
      <el-tabs v-model="searchForm.type">
        <el-tab-pane label="海关关区" name="customs_area"></el-tab-pane>
        <el-tab-pane label="运输方式" name="transport_mode"></el-tab-pane>
        <el-tab-pane label="监管方式" name="supervision_mode"></el-tab-pane>
        <el-tab-pane label="征免性质" name="tax_nature"></el-tab-pane>
        <el-tab-pane label="国别" name="country"></el-tab-pane>
        <el-tab-pane label="国内地区" name="domestic_area"></el-tab-pane>
        <el-tab-pane label="监管类别名称" name="supervision_category"></el-tab-pane>
        <el-tab-pane label="指运港" name="destination_port"></el-tab-pane>
        <el-tab-pane label="成交方式" name="trade_mode"></el-tab-pane>
        <el-tab-pane label="包装种类" name="packaging_type"></el-tab-pane>
        <el-tab-pane label="报关单类型" name="declaration_type"></el-tab-pane>
        <el-tab-pane label="离境口岸" name="exit_port"></el-tab-pane>
        <el-tab-pane label="随附单证代码" name="document_code"></el-tab-pane>
        <el-tab-pane label="随附单据文件类别" name="document_category"></el-tab-pane>
        <el-tab-pane label="计量单位" name="unit"></el-tab-pane>
        <el-tab-pane label="币种" name="currency"></el-tab-pane>
        <el-tab-pane label="征免方式" name="tax_mode"></el-tab-pane>
        <el-tab-pane label="用途" name="purpose"></el-tab-pane>
        <el-tab-pane label="危险品包装类别" name="dangerous_packaging"></el-tab-pane>
        <el-tab-pane label="集装箱规格" name="container_spec"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="button-toolbar">
      <el-button @click="handleSaveSort">保存排序</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showChangeRecord(scope.row)">变更记录</el-button>
          <el-button v-if="scope.row.enabled" type="text" size="small" @click="toggleEnabled(scope.row, false)" style="color: red;">禁用</el-button>
          <el-button v-else type="text" size="small" @click="toggleEnabled(scope.row, true)">启用</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="code1" label="编码1" width="120"></el-table-column>
      <el-table-column prop="name" label="中文名称" width="200"></el-table-column>
      <el-table-column prop="enabled" label="是否启用" width="80">
        <template slot-scope="scope">
          <span :class="scope.row.enabled ? 'status-enabled' : 'status-disabled'">
            {{ scope.row.enabled ? '是' : '否' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="expired" label="是否过期" width="80">
        <template slot-scope="scope">
          <span :class="scope.row.expired ? 'status-expired' : 'status-not-expired'">
            {{ scope.row.expired ? '是' : '否' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="排序" width="180">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.sortOrder" :min="-999" :max="999" :step="1" size="mini" controls-position="right" @change="handleSortChange"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="code2" label="编码2" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.code2 || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="code3" label="编码3" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.code3 || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fullName" label="中文全称"></el-table-column>
      <el-table-column prop="enName" label="英文名称"></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 变更记录弹框 -->
    <el-dialog
      :title="`基础参数变更记录(${selectedName})`"
      :visible.sync="dialogVisible"
      width="70%"
      :close-on-click-modal="true">
      <el-table :data="changeRecords" style="width: 100%">
        <el-table-column prop="time" label="变更时间"></el-table-column>
        <el-table-column prop="field" label="字段"></el-table-column>
        <el-table-column prop="oldValue" label="原值"></el-table-column>
        <el-table-column prop="newValue" label="新值"></el-table-column>
        <el-table-column prop="user" label="变更用户"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BaseParam',
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 150,
      dialogVisible: false,
      selectedName: '',
      changeRecords: [],
      searchForm: {
        type: 'customs_area',
        name: '',
        enName: '',
        code1: '',
        code2: '',
        code3: '',
        enabled: '',
        expired: ''
      },
      typeMap: {
        customs_area: '海关关区',
        transport_mode: '运输方式',
        supervision_mode: '监管方式',
        tax_nature: '征免性质',
        country: '国别',
        domestic_area: '国内地区',
        supervision_category: '监管类别名称',
        destination_port: '指运港',
        trade_mode: '成交方式',
        packaging_type: '包装种类',
        declaration_type: '报关单类型',
        exit_port: '离境口岸',
        document_code: '随附单证代码',
        document_category: '随附单据文件类别',
        unit: '计量单位',
        currency: '币种',
        tax_mode: '征免方式',
        purpose: '用途',
        dangerous_packaging: '危险品包装类别',
        container_spec: '集装箱规格'
      }
    }
  },
  mounted() {
    this.generateTableData()
  },
  methods: {
    generateTableData() {
      this.tableData = [
        {
          id: 1,
          type: 'customs_area',
          name: '北京海关',
          fullName: '中华人民共和国北京海关',
          enName: 'Beijing Customs',
          code1: '1100',
          code2: 'BJC',
          code3: '',
          sortOrder: 1,
          enabled: true,
          expired: false
        },
        {
          id: 2,
          type: 'customs_area',
          name: '上海海关',
          fullName: '中华人民共和国上海海关',
          enName: 'Shanghai Customs',
          code1: '2200',
          code2: 'SHC',
          code3: '',
          sortOrder: 2,
          enabled: true,
          expired: false
        },
        {
          id: 3,
          type: 'customs_area',
          name: '广州海关',
          fullName: '中华人民共和国广州海关',
          enName: 'Guangzhou Customs',
          code1: '4400',
          code2: 'GZC',
          code3: '',
          sortOrder: 3,
          enabled: false,
          expired: false
        },
        {
          id: 4,
          type: 'transport_mode',
          name: '海运',
          fullName: '海洋运输',
          enName: 'Sea Transport',
          code1: '2',
          code2: '',
          code3: '',
          sortOrder: 4,
          enabled: true,
          expired: false
        },
        {
          id: 5,
          type: 'transport_mode',
          name: '空运',
          fullName: '航空运输',
          enName: 'Air Transport',
          code1: '5',
          code2: '',
          code3: '',
          sortOrder: 5,
          enabled: true,
          expired: false
        },
        {
          id: 6,
          type: 'transport_mode',
          name: '陆运',
          fullName: '陆地运输',
          enName: 'Land Transport',
          code1: '4',
          code2: '',
          code3: '',
          sortOrder: 6,
          enabled: false,
          expired: true
        },
        {
          id: 7,
          type: 'supervision_mode',
          name: '一般贸易',
          fullName: '一般贸易',
          enName: 'General Trade',
          code1: '0110',
          code2: '',
          code3: '',
          sortOrder: 7,
          enabled: true,
          expired: false
        },
        {
          id: 8,
          type: 'supervision_mode',
          name: '加工贸易',
          fullName: '加工贸易',
          enName: 'Processing Trade',
          code1: '0615',
          code2: '',
          code3: '',
          sortOrder: 8,
          enabled: true,
          expired: true
        },
        {
          id: 9,
          type: 'country',
          name: '中国',
          fullName: '中华人民共和国',
          enName: 'China',
          code1: '142',
          code2: 'CHN',
          code3: '',
          sortOrder: 9,
          enabled: true,
          expired: false
        },
        {
          id: 10,
          type: 'unit',
          name: '台',
          fullName: '台',
          enName: 'Unit',
          code1: '012',
          code2: '',
          code3: '',
          sortOrder: 10,
          enabled: false,
          expired: false
        }
      ]
    },
    handleSearch() {
      this.currentPage = 1
      this.generateTableData()
    },
    handleReset() {
      this.searchForm = {
        type: 'customs_area',
        name: '',
        enName: '',
        code1: '',
        code2: '',
        code3: '',
        enabled: '',
        expired: ''
      }
      this.currentPage = 1
      this.generateTableData()
    },
    handleSaveSort() {
      this.$confirm('是否保存参数排序？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableData.sort((a, b) => a.sortOrder - b.sortOrder)
        this.$message({ type: 'success', message: '排序保存成功' })
      }).catch(() => {})
    },
    handleSortChange() {
    },
    toggleEnabled(row, enabled) {
      row.enabled = enabled
      this.$message({
        type: 'success',
        message: `参数 "${row.name}" 已${enabled ? '启用' : '禁用'}`
      })
    },
    showChangeRecord(row) {
      this.selectedName = row.name
      this.changeRecords = [
        { time: '2026-04-28 14:30:25', field: '编码1', oldValue: '1100', newValue: '1101', user: '张三' },
        { time: '2026-04-27 10:15:00', field: '中文名称', oldValue: '北京海关', newValue: '北京海关（新版）', user: '李四' },
        { time: '2026-04-26 09:00:00', field: '排序', oldValue: '1', newValue: '0.5', user: '王五' },
        { time: '2026-04-25 16:20:00', field: '是否启用', oldValue: '是', newValue: '否', user: '赵六' },
        { time: '2026-04-24 11:30:00', field: '是否启用', oldValue: '否', newValue: '是', user: '钱七' }
      ]
      this.dialogVisible = true
    },
    handleSizeChange(size) {
      this.pageSize = size
    },
    handleCurrentChange(current) {
      this.currentPage = current
    }
  }
}
</script>

<style scoped>
.base-param {
  padding: 0;
}

.search-container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid var(--border-color);
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
}

.search-form >>> .el-form-item {
  margin-bottom: 0;
}

.search-form >>> .el-form-item__label {
  font-weight: 500;
  color: var(--text-secondary);
}

.status-filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border-color);
}

.status-filter-label {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 14px;
  white-space: nowrap;
}

.status-filter-group {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.status-filter-group .el-radio-group {
  display: flex;
  gap: 0;
}

.status-filter-group .el-radio {
  padding: 6px 14px;
  margin: 0;
  border: 1px solid var(--border-color);
  border-radius: 0;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
  color: var(--text-secondary);
}

.status-filter-group .el-radio:first-child {
  border-radius: 6px 0 0 6px;
}

.status-filter-group .el-radio:last-child {
  border-radius: 0 6px 6px 0;
}

.status-filter-group .el-radio:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
  z-index: 1;
}

.status-filter-group .el-radio.is-checked {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
  z-index: 1;
}

.status-filter-group .el-radio + .el-radio {
  margin-left: 0;
}

.type-tabs {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 0 20px;
  margin-bottom: 16px;
  border: 1px solid var(--border-color);
}

.type-tabs >>> .el-tabs__header {
  margin-bottom: 0;
}

.type-tabs >>> .el-tabs__nav-wrap::after {
  display: none;
}

.type-tabs >>> .el-tabs__item {
  font-size: 14px;
  color: var(--text-secondary);
  height: 50px;
  line-height: 50px;
}

.type-tabs >>> .el-tabs__item.is-active {
  color: var(--primary-color);
  font-weight: 600;
}

.type-tabs >>> .el-tabs__active-bar {
  height: 3px;
}

.button-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border-color);
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid var(--border-color);
}

.status-enabled {
  color: var(--success-color);
  font-weight: 500;
}

.status-disabled {
  color: var(--danger-color);
  font-weight: 500;
}

.base-param .el-table .el-input-number {
  width: 100px;
}

.base-param .el-table .el-input-number .el-input__inner {
  padding-left: 5px;
  padding-right: 5px;
}

.status-expired {
  color: var(--warning-color);
  font-weight: 500;
}

.status-not-expired {
  color: var(--success-color);
  font-weight: 500;
}

.form-container {
  padding: 20px 0;
}

.form-container >>> .el-form-item {
  margin-bottom: 20px;
}

.base-param >>> .el-table {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--border-color);
}

.base-param >>> .el-table th {
  background-color: #fafafa !important;
  font-weight: 600;
  color: var(--text-primary);
  font-size: 13px;
}

.base-param >>> .el-table td {
  padding: 12px 0;
  font-size: 13px;
}

.base-param >>> .el-table__row:hover > td {
  background-color: var(--primary-bg) !important;
}

.base-param >>> .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.base-param >>> .el-dialog__header {
  background-color: #fff;
  border-bottom: 1px solid var(--border-color);
  padding: 18px 24px;
}

.base-param >>> .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.base-param >>> .el-dialog__body {
  padding: 20px 24px;
}

.base-param >>> .el-dialog__footer {
  border-top: 1px solid var(--border-color);
  padding: 14px 24px;
}
</style>